import { differenceInDays, startOfDay } from 'date-fns';

// TODO refactor. authService uses the same prefix (storageKeyPrefix)
export function markLastOpen(storageKeyPrefix: string): void {
    try {
        const key = `${storageKeyPrefix}_eventCentreLastOpen`;
        localStorage.setItem(key, new Date().toJSON());
    } catch {}
}

export function shouldOpenSinceLastOpen(storageKeyPrefix: string): boolean {
    try {
        const key = `${storageKeyPrefix}_eventCentreLastOpen`;
        const value = localStorage.getItem(key);
        const d = new Date(value);
        if (isNaN(d.getTime())) {
            return false;
        }
        return differenceInDays(startOfDay(new Date()), startOfDay(d)) >= 1;
    } catch {}
    return false;
}
